import type { AxiosInstance } from "axios";

import type { InstrumentDigest } from "@thalamos/haven-common";

import type { ErrorBody, ResponseBody } from "../axios/api.js";

export const config = {
  instrument: {
    /**
     * One published version's schema, by the digest an assessment pins.
     *
     * Returned unparsed: the body is JSON Schema, for a caller to judge with
     * `parsePublishedInstrumentSchema`, which refuses anything outside the
     * subset an instrument may be published in.
     */
    schema: (digest: InstrumentDigest) => ({
      url: `/api/instruments/${encodeURIComponent(digest)}`,
      method: "get",
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    instrument: {
      schema: (digest: InstrumentDigest) =>
        apiAxios.request<ResponseBody<unknown, ErrorBody>>(
          config.instrument.schema(digest),
        ),
    },
  };
};
